import { fetchApi } from "../../../../lib/fetchApi";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { normalizeBinaryState } from "../../../../utils/activeStateUtils";
import { DictionaryFormDto, ListFields } from "../types";

// TODO: compare with basicGenericApi and see which one should be used and if there is anything missing
export interface IDictionaryApi {
    search(body: PaginationFilterDto): Promise<Pagination<ListFields>>;
    getDetail(id: string): Promise<DictionaryFormDto>;
    save(body: DictionaryFormDto): Promise<DictionaryFormDto>;
    update(body: DictionaryFormDto): Promise<DictionaryFormDto>;
    exportCsv(): Promise<DictionaryFormDto>;
    getSelectOptions(): Promise<SelectItemDto[]>;
}

export function mapDictionaryState(data: ListFields): ListFields {    
    const deletedAt = (data as any).deletedDate ?? (data as any).dataBaixa;

    return {
        ...data,
        state: normalizeBinaryState(data.state, deletedAt)
    };
}

export function createDictionaryApiFactory(resource: string): IDictionaryApi {
    return {
        async search(body) {
            const response = await fetchApi.post(`/${resource}/search`, body) as Pagination<ListFields>;
            return { ...response, items: response.items.map(mapDictionaryState) };
        },
        async getDetail(id) {
            return await fetchApi.get(`/${resource}/detail/${id}`) as DictionaryFormDto;
        },
        async save(body) {
            return await fetchApi.post(`/${resource}/save`, body) as DictionaryFormDto;
        },
        async update(body) {
            return await fetchApi.post(`/${resource}/edit`, body) as DictionaryFormDto;
        },
        async exportCsv() {
            return await fetchApi.get(`/${resource}/exportCsv`) as DictionaryFormDto;
        },
        async getSelectOptions() {
            return await fetchApi.get(`/${resource}/select`) as SelectItemDto[];
        }
    };
}
